'use strict';

module.exports = require('./Switch');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-switch/lib/index.js
 ** module id = 626
 ** module chunks = 0
 **/